import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { selectSettingStyle } from 'src/app/stores/settings';

import { ConnectionService } from '../../services/connection-service/connection.service';

@Component({
  selector: 'frodo-connection-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './connection-indicator.component.html',
  styleUrls: ['./connection-indicator.component.scss'],
})
export class ConnectionIndicatorComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  isOnline = false;
  onlineConnectionIcon: string;
  offlineConnectionIcon: string;
  connectionIconAlt = 'connection indicator';

  constructor(private store: Store, private connectionService: ConnectionService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.connectionService.checkConnection().subscribe((isOnline) => (this.isOnline = isOnline))
    );

    this.subscription.add(
      this.store.select(selectSettingStyle).subscribe((style) => {
        this.onlineConnectionIcon = style.icons.onlineConnection;
        this.offlineConnectionIcon = style.icons.offlineConnection;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
